module.exports = __webpack_public_path__ + "static/media/why-choose-img2.95b514f4.jpg";